module.exports = __webpack_public_path__ + "static/media/german_engineer_motorized_120.eb0e5c1a.png";